import { useState } from "react";
import { useParams } from "react-router-dom";
import useDataFetch, { DataFetchOptionsType } from "../../hooks/useDataFetch";
import { getAssessmentDetails, getCandidatesData } from "./services";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import RenderHeader from "./partials/renderHeader";
import ReportGrid from "./components/ReportGrid";
import PageWrapper from "../../components/PageWrapper";

const AssessmentReport = () => {
  const { assessmentId } = useParams();
  //   const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
  //     error: { msg: "API Failed" },
  //   });
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  const { loading, data, error } = useDataFetch(
    fetchAssessmentDetails,
    fetchOptions
  );

  const [visibleColumns, setVisibleColumns] = useState([]);

  async function fetchAssessmentDetails() {
    let assessmentDetails: any = await Promise.all([
      getAssessmentDetails(assessmentId),
      getCandidatesData(assessmentId),
    ]);

    return {
      headerData: { ...assessmentDetails[0] },
      gridData: [...assessmentDetails[1]],
    };
  }

  if (loading) {
    return <RenderLoading />;
  }

  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions({
            loading: true,
          });
          setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
          }, 1000);
        }}
      />
    );
  }

  return (
    <PageWrapper>
      <div className="card row h-full">
        <div className="col-12 h-[30%]">
          {
            <RenderHeader
              data={data.headerData}
              assessmentId={assessmentId}
              reportData={data.gridData}
              visibleColumns={visibleColumns}
            />
          }
        </div>
        <div className="col-12 h-[70%] row justify-center items-center overflow-hidden xl:p-4">
          {
            <ReportGrid
              gridDataAPI={data.gridData}
              assessmentId={assessmentId}
              visibleColumns={visibleColumns}
              setVisibleColumns={setVisibleColumns}
              headerData={data.headerData}
            />
          }
        </div>
      </div>
    </PageWrapper>
  );
};

export default AssessmentReport;
